export function metaReportCacheKey(from, to, platform = 'both') {
    return `${from}|${to}|${platform || 'both'}`;
}

export function googleReportCacheKey(from, to) {
    return `${from}|${to}`;
}

export function combinedReportCacheKey(from, to) {
    return `${from}|${to}`;
}

export function metaCityDailyCacheKey(from, to, platform, campaignIdsKey) {
    return `${from}|${to}|${platform || 'both'}|${campaignIdsKey || ''}`;
}
